"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SingleCard_1 = require("./SingleCard");
var DoubleCard_1 = require("./DoubleCard");
var TripleCard_1 = require("./TripleCard");
var RollableCard_1 = require("./RollableCard");
var utils_1 = require("./utils");
function TomatoCard(props) {
    var isRollable = props.isRollable, customUI = props.customUI;
    var columnNum = props.columnNum;
    var _a = utils_1.getTomatoWidth(columnNum, customUI, isRollable), imgWidth = _a.imgWidth, imgHeight = _a.imgHeight;
    var commonProps = {
        product: props === null || props === void 0 ? void 0 : props.productElement,
        imgWidth: imgWidth,
        imgHeight: imgHeight
    };
    if (![1, 2, 3].includes(columnNum)) {
        columnNum = 2;
    }
    var ProductSkeleton;
    switch (columnNum) {
        case 1:
            ProductSkeleton = SingleCard_1.default;
            break;
        case 2:
            if (isRollable) {
                ProductSkeleton = RollableCard_1.default;
            }
            else {
                ProductSkeleton = DoubleCard_1.default;
            }
            break;
        case 3:
            ProductSkeleton = TripleCard_1.default;
            break;
        default:
            ProductSkeleton = DoubleCard_1.default;
    }
    return React.createElement(ProductSkeleton, __assign({}, commonProps));
}
exports.default = TomatoCard;
